import React, { useRef } from "react";
import Layout from "./layout";
import DataTable from "../components/DataTable";
import SegmentData from "../assets/json/segment.json";

const Segment = () => {
  const tableRef = useRef();

  const columns = [
    { headname: "Segment Name", type: "text", dbcol: "col1" },
    { headname: "Segment Size", type: "text", dbcol: "col2" },
    { headname: "Last Activity", type: "text", dbcol: "col3" },
    { headname: "Author", type: "text", dbcol: "col4" },
  ];

  return (
    <Layout>
      

      <DataTable
        id="table1"
        tableRef={tableRef}
        columns={columns}
        data={SegmentData}
        defaultView="table"
        searchable={true}
        filterable={true}
        sortable={true}
        paginated={true}
      />
    </Layout>

  );
};

export default Segment;
